import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

const buildIcon = (cls) => {
  const el = document.createElement('i')
  el.className = `${cls} me-2`
  return el
}

export default class extends Controller {
  static targets = ["select"]

  connect() {
    const d = Choices.defaults.templates

    this.choices = new Choices(this.selectTarget, {
      searchResultLimit: 30,
      renderChoiceLimit: 30,
      shouldSort: false,
      callbackOnCreateTemplates() {
        return {
          item(config, choice, removeItemButton) {
            const el = d.item.call(this, config, choice, removeItemButton)
            if (choice.value) el.insertBefore(buildIcon(choice.value), el.firstChild)
            return el
          },
          choice(config, choice, selectText, groupName) {
            const el = d.choice.call(this, config, choice, selectText, groupName)
            if (choice.value) el.insertBefore(buildIcon(choice.value), el.firstChild)
            return el
          }
        }
      }
    })
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy()
      this.choices = null
    }
  }
}
